export default [
/*   {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
  }, */
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    meta: {
      resource: 'Dashboard',
      action: 'read',
    },
  },
  {
    path: '/dashboard/wallets',
    name: 'wallets',
    component: () => import('@/views/dashboard/wallets/Index.vue'),
  },
  {
    path: '/dashboard/wallet/:id',
    name: 'wallets-detail',
    component: () => import('@/views/dashboard/wallets/WalletView.vue'),
    meta: {
      resource: 'all',
      action: 'read',
    },
  },
  {
    path: '/dashboard/client/wallet/:id',
    name: 'wallets-client-detail',
    component: () => import('@/views/dashboard/wallets/WalletView.vue'),
    meta: {
      resource: 'ClientWallet',
      action: 'read',
    },
  },
  {
    path: '/dashboard/currencies',
    name: 'currencies',
    component: () => import('@/views/dashboard/currencies/Index.vue'),
    meta: {
      resource: 'Currency',
      action: 'read',
    },
  },
  {
    path: '/dashboard/currency/:id',
    name: 'currency-detail',
    component: () => import('@/views/dashboard/currencies/CurrencyView.vue'),
    meta: {
      resource: 'Currency',
      action: 'read',
    },
  },
  {
    path: '/dashboard/users',
    name: 'users',
    component: () => import('@/views/dashboard/users/Index.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/dashboard/user/:id',
    name: 'users-detail',
    component: () => import('@/views/dashboard/users/UserView.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/dashboard/roles',
    name: 'roles.index',
    component: () => import('@/views/dashboard/roles/Index.vue'),
  },
  {
    path: '/dashboard/clients',
    name: 'clients',
    component: () => import('@/views/dashboard/clients/Index.vue'),
    meta: {
      resource: 'Client',
      action: 'read',
    },
  },
  {
    path: '/dashboard/client/:id',
    name: 'clients-detail',
    component: () => import('@/views/dashboard/clients/ClientView.vue'),
    meta: {
      resource: 'Client',
      action: 'read',
    },
  },
  {
    path: '/dashboard/audit',
    name: 'audit',
    component: () => import('@/views/dashboard/audit/Index.vue'),
    meta: {
      resource: 'Audit',
      action: 'read',
    },
  },
]
